/**
 * 彩易分析 - 系统常量 - 系统默认
 * https://menger.me
 * @大梦
 */

'use strict';


export default {
    /**
     * @开发测试账号
     */
    DEV_ACCOUNT: [
        '001',
        '002',
        'asd',
        'dev',
    ],

    /**
     * @版本
     */
    APP_PLATFORM: 1,
    APP_NAME: '智选通',
    VERSION_CODE: 'VERSION_DATA.version_code',
    VERSION_NAME: 'VERSION_DATA.version_name',

    /**
     * @七牛云图片裁剪
     */
    IMAGE_CROP_OPTIONS: '?imageView2/2/w/100/h/100',
    /**
     * @七牛云视频缩略图
     */
    VIDEO_FRAME: '?vframe/jpg/offset/1',

    /**
     * @首次打开APP
     */
    FIRST_OPEN: 'FIRSTOPEN',

    /**
     * @首次展示隐私政策
     */
    SHOW_PRIVACY_POLICY: 'SHOWPRIVACYPOLICY',
    
    /**
     * @存储用户信息
     */
    USER_INFO_KEY: 'USERINFOKEY',

    /**
     * @短信验证码类型
     */
    // SMS_NORMAL
    SMS_NORMAL: 'sms_normal',
    // SMS_REGISTER
    SMS_REGISTER: 'sms_register',
    // SMS_RESET
    SMS_RESET: 'sms_reset',
    // SMS_BIND_MOBILE
    SMS_BIND_MOBILE: 'sms_bind_mobile',

    /**
     * @数据类型
     */
    DATE: 'date',
    TIME: 'time',
    TEXT: 'text',
    ARRAY: 'array',
    IMAGE: 'image',
    INPUT: 'input',
    SELECT: 'select',
    TEXTAREA: 'textArea',
    DATE_TIME: 'datetime',
    TIME_DAY: '天',
    TIME_HOUR: '时',
    TIME_MINUTE: '分',
    TIME_SECONDS: '秒',

    /**
     * @分享参数
     */
    // 微信好友
    SHARE_WE_CHAT: 1,
    // 微信朋友圈
    SHARE_TIME_LIME: 2,
    // QQ好友
    SHARE_QQ: 3,
    // QQ空间
    SHARE_QQ_ZONE: 4,
    // 新浪微博
    SHARE_SINA: 6,
    // 复制链接
    SHARE_LINK: 5,

    /**
     * @地区选择插件
     */
    // 热门城市
    HOT_CITY: '热门城市',

    /**
     * @链接打开类型
     */
    // app内页
    OPEN_APP_PAGE: 1,
    // app内打开
    OPEN_APP_WEB: 2,
    // 手机默认浏览器打开
    OPEN_MOBILE_WEB: 3,

    /**
     * @系统组件
     */
    // Button icon的位置
    POSITION_TOP: 'top',
    POSITION_LEFT: 'left',
    POSITION_RIGHT: 'right',
    POSITION_BOTTOM: 'bottom',

    /**
     * @列表相关
     */
    // 加载完毕提醒
    ALL_LOAD_TIPS: '-- 数据已全部加载完毕 --',

    /**
     * @性别设置
     */
    sex: {
        0: '保密',
        1: '男',
        2: '女',
    },

    /**
     * @云图库
     */
    // 七牛云
    DRIVER_QINIUKODO: 'qiniu-kodo',
    // 阿里云
    DRIVER_ALIOSS: 'ali-oss',
    // 腾讯云
    DRIVER_TENCENTCOS: 'tencent-cos',


};